import { Constructor } from '../../global/constructor';
import Notification from '~/models/notifications/notification';
import { RelationType } from '~/models/relationType';
import NotificationFactory from '~/models/notifications/notificationFactory';
import TrackedModel from '~/models/tracked/trackedModel';
import { ITrackedModel } from '~/interfaces/modelInterfaces';
import { ObjectHelper } from '~/helpers/objectHelper';
import { Hash } from '~/interfaces/hashInterfaces';

export interface INotificationsContainer extends ITrackedModel {
  notifications: { [key: string]: Notification };
  notificationFactory: NotificationFactory;

  createNotification(): Notification;

  notificationsArray(): Notification[];
}

export default function NotificationsContainable<TBase extends Constructor<TrackedModel>>(Base: TBase): typeof Base & Constructor<INotificationsContainer> {
  abstract class NotificationsContainer extends Base implements INotificationsContainer {
    notifications: { [key: string]: Notification } = {};

    get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
      return {
        ...super.EMBEDDED_MODELS,
        'notifications': { type: Notification, relationType: RelationType.dictionary },
      };
    }

    createEmbeddedObject = {
      ...this.createEmbeddedObject,
      notifications: (parent, json?): Notification => this.notificationFactory.create(parent),
    };

    abstract get notificationFactory(): typeof NotificationFactory

    createNotification(): Notification {
      return this.createEmbeddedObject.notifications(this);
    }

    notificationsArray(): Notification[] {
      return ObjectHelper.toArray(this.notifications);
    }
  }

  return NotificationsContainer;
}